import { render, staticRenderFns } from "./gift-card-detail.vue?vue&type=template&id=1d147aa4&scoped=true&"
import script from "./gift-card-detail.vue?vue&type=script&lang=js&"
export * from "./gift-card-detail.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-detail.vue?vue&type=style&index=0&id=1d147aa4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d147aa4",
  null
  
)

export default component.exports